/**
 * @file swap
 * @author yuzong(yuzong@tencent.com)
 */
import { assign } from '@tencent/glue-util-helper';
import { getKeys } from '@tencent/glue-util-types';
export function swap(element, styles, callback) {
  var old = {};
  var keys = getKeys(styles); // fixme typeError

  keys.forEach(function (key) {
    return old[key] = element.style[key];
  });
  assign(element.style, styles);
  var result = callback();
  assign(element.style, old);
  return result;
}